import { Box, Button } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { ECounterType } from "@tm/models"
import { TmaHelper } from "@tm/utils"

type Props = {
    disabled: boolean
    showArticleNumberSearch?: boolean
    onOpenVouchersList(): void
}

export function VoucherWidgetFooter(props: Props) {
    const { disabled, onOpenVouchersList, showArticleNumberSearch } = props
    const { translateText } = useLocalization()

    function handleOpenVouchersList() {
        TmaHelper.GeneralCountEvent.Call(ECounterType.VoucherList)
        onOpenVouchersList()
    }

    return (
        <Box display="flex" justifyContent={showArticleNumberSearch ? "flex-end" : "flex-start"}>
            <Button onClick={handleOpenVouchersList} disabled={disabled} size="medium">
                {translateText(13925)}
            </Button>
        </Box>
    )
}
